<template>
  <div class="dropdown-choose-location mobile-filter-district">
    <Input
      :value="districtStr"
      :readonly="true"
      :placeholder="$t('placeholder.district')"
      :disabled="isInputActive"
      @click.native="show = !isInputActive"
    />
    <el-dialog
      class="location-modal"
      :modal-append-to-body="false"
      :visible.sync="show"
      width="100%"
      :center="true"
      :show-close="true"
      :lock-scroll="true"
    >
      <div class="dialog-body">
        <Districts @clicked="show = false" />
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import Input from '~/components/Common/Input'
import Districts from '~/components/Dropdowns/Parts/Districts'

export default {
  name: 'District',
  components: {
    Input,
    Districts
  },
  data() {
    return {
      districtStr: '',
      show: false
    }
  },
  computed: {
    ...mapGetters({
      searchSubway: 'search/searchSubway',
      getDistrict: 'search/searchDistrict',
      getMicroDistrict: 'search/searchMicroDistrict'
    }),
    isInputActive() {
      return !!this.searchSubway.length
    }
  },
  watch: {
    getDistrict() {
      this.districtStr = this.districtString()
    },
    getMicroDistrict() {
      this.districtStr = this.districtString()
    }
  },
  mounted() {
    this.districtStr = this.districtString()
  },
  methods: {
    districtString() {
      return [
        ...this.getDistrict.map((item) => item.title),
        ...this.getMicroDistrict.map((item) => item.title)
      ].join(', ')
    }
  }
}
</script>

<style scoped></style>
